import { MdLocationOn } from 'react-icons/md';
import { useMemo } from 'react';

// Initial "Initials Function"
// const getInitials = (name) => {
//   if (!name) return '?';
//   return name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
// };

//Initials Function from KybDetails.jsx
const getInitials = (name) => {
  if (!name) return '?';
  return name.split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join('');
};

const formatPhone = (phone) => {  
  if (!phone) return 'N/A';

  const phoneString = String(phone);

  // Add 0 only if the number doesn't already start with 0
  return phoneString.startsWith('0') ? phoneString : `0${phoneString}`;
};

const ClientDetails = ({clientsdetails}) => {
  const initials = useMemo(() => getInitials(clientsdetails?.companyName), [clientsdetails?.companyName]);
  const hasLogo = clientsdetails?.companyLogo;

  return (
    <section id='client-details'>
      <div>
        <h2 className='text-xl lg:text-2xl font-semibold leading-8 mb-4 text-brand-navy'>
          Client's details
        </h2>
        <div className='flex flex-col items-start lg:flex-row lg:flex-wrap  gap-10 lg:gap-20'>
          <div className='flex gap-[18px] items-center'>
            <div className='w-11 h-11'>
              {/* {hasLogo ? (
                <img alt='avatar' src={clientsdetails.companyLogo} className='w-11 h-11 rounded-full object-cover' />
              ) : (
                <div className='w-11 h-11 rounded-full bg-brand-navy flex items-center justify-center text-white font-bold text-sm'>
                  {initials}
                </div>
              )} */}
              <div className='w-11 h-11 rounded-full bg-[#9CA3AF] flex items-center justify-center text-white font-bold text-sm'>
                {initials}
              </div>
            </div>
            <span className={`text-brand-navy lg:text-lg`}>{clientsdetails?.companyName}</span>
          </div>
          <div>
            <div className='flex gap-3 items-center'>
              <h3 className='text-xl font-semibold'>Location</h3>
              <MdLocationOn width={14} height={20} color='#E27D03' />
            </div>
            <p className='lg:text-lg'>{clientsdetails?.companyLocation}</p>
          </div>
          <div className='flex flex-col gap-3.5 justify-center'>
            <div className='flex items-center gap-9'>
              <h3 className='text-xl font-semibold'>Phone:</h3>
              <p className='lg:text-lg text-muted-foreground'>{formatPhone(clientsdetails?.phone)}</p>
            </div>
            <div className='flex items-center gap-9'>
              <h3 className='text-xl font-semibold'>Email:</h3>
              <p className='lg:text-lg text-muted-foreground'>
                {clientsdetails?.email}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientDetails;
